import React from 'react';
import { Icon, IconName } from '@cotera/client/app/components/ui/icon';
import { classNames } from '@cotera/client/app/components/utils';

export type ActivityCardProps = {
  icon: IconName;
  title: string;
  subtitle?: string;
  timestamp: string;
  onClick?: () => void;
  className?: string;
};

export const ActivityCard: React.FC<ActivityCardProps> = ({
  icon,
  title,
  subtitle,
  timestamp,
  onClick,
  className,
}) => {
  return (
    <div
      onClick={onClick}
      className={classNames(
        'relative flex flex-col justify-between p-4 rounded-xl border border-slate-200 bg-white shadow-sm min-h-[120px]',
        'hover:bg-slate-50 transition-all duration-200 cursor-pointer',
        'group',
        className
      )}
    >
      {/* Icon in top-right corner */}
      <div className="absolute top-4 right-4 w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-slate-200 transition-colors">
        <Icon icon={icon} className="w-5 h-5 text-slate-600" />
      </div>

      {/* Content */}
      <div className="flex flex-col gap-2 pr-14">
        <h3 className="font-semibold text-slate-900 leading-snug text-base">
          {title}
        </h3>
        <p className="text-sm text-slate-500 min-h-[20px]">
          {subtitle || '\u00A0'}
        </p>
      </div>

      {/* Timestamp at bottom */}
      <div className="text-xs text-slate-400">{timestamp}</div>
    </div>
  );
};
